// src/constants/buildingTypes.js

export const BUILDING_TYPE_CHOICES = [
    'Apartment building',
    'Tenement house',
    'Condominium',
    'Detached house',
    'Semi-detached house',
    'Townhouse',
    'Duplex',
    'Loft',
    'Bungalow',
    'Skyscraper',
    'Villa',
  ];
  